<script setup lang="ts">
import { useDefinitionStore } from '~/stores/definitions'
import AppCard from '@/components/card/AppCard.vue'
import { Page } from '~/types/types'
useSeoMeta({
  title: () => `Drivmedla - Om Drivmedla`,
  description: () =>
    'Läs på om vad Drivmedla är, vad det fyller för syfte samt vilka initiativtagarna är.',
  ogTitle: () => `Drivmedla - Om Drivmedla`,
  ogDescription: () =>
    'Läs på om vad Drivmedla är, vad det fyller för syfte samt vilka initiativtagarna är.',
  ogLocale: () => 'sv_SE',
  ogSiteName: () => 'Drivmedla',
  ogUrl: () => `${useRuntimeConfig().public.baseURL}${useRoute().fullPath}`,
  ogImage: () => `${useRuntimeConfig().public.baseURL}/_nuxt/assets/_logo-horizontal-GREEN.svg`,
})
const { keyTranslator: definitionsTranslator } = await useKeyTranslator('definitions')
const definitionStore = useDefinitionStore()
const { findOne } = useStrapi()
const { data: pageInfo } = await useAsyncData(
  'definitions-page',
  () => findOne<Page>('definitions-page', { populate: '*' }),
  { transform: (_pageInfo) => _pageInfo.data }
)
const definitions = computed(() => definitionStore.getAllDefinitionsByGroup)

onMounted(async () => {
  await definitionStore.initDefinitions()
})
</script>
<template>
  <div>
    <AppHero
      :title="pageInfo?.attributes.generalContent.title"
      :description="pageInfo?.attributes.generalContent.ingress"
    />
    <LayoutSection v-if="Object.keys(definitions).length > 0" class="definitions">
      <div class="flex justify-content-center my-6">
        <div class="col-12 sm:col-12 md:col-10 lg:col-7">
          <AppCard
            v-for="(groupDefinitions, groupName) in definitions"
            :key="groupName"
            class="mb-4"
          >
            <h3>{{ definitionsTranslator(groupName) }}</h3>
            <div
              v-for="(definition, index) in groupDefinitions"
              :key="index"
              class="definitions__item"
            >
              <h4>{{ definition.title }}</h4>
              <p>{{ definition.description }}</p>
            </div>
          </AppCard>
        </div>
      </div>
    </LayoutSection>
  </div>
</template>
<style scoped lang="scss">
.definitions {
  &__item {
    &:first-of-type {
      h4 {
        margin-top: 0;
      }
    }

    h4 {
      margin-top: 1rem;
    }
  }
}
</style>
